module.exports = __webpack_public_path__ + "img/gm.414139d5.svg";